import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Card from "../ui/card/card";
import HelpLineTitle from "../ui/helpline-title/helplineTitle";
import Tag from "../ui/tag/tag";
import Flex from "../ui/flex/flex";
import HowItWork from "../ui/howItWork/howItWork";
import Popup from "../ui/popup/popup";
import { Faq } from "../ui/faq/faq";
import LoginButton from "../ui/button/login";
import useUserStore from "../data/store/useUserStore";
import PhoneNumberForm from "../ui/form/phoneNumberForm";
import YouAreAnonymous from "../ui/anonymous/anonymous";
import TermsConditions from "../ui/terms/terms";
import PoweredBy from "../ui/poweredBy/poweredBy";
import useDataStore from "../data/store/useDataStore";
import PageNotExist from "../ui/pageNotExist/pageNotExist";
import { t } from 'ttag';
import LangSwitcher from "../ui/dropdown/langSwitcher";

const Main = () => {
  const navigate = useNavigate();
  const { companyId } = useParams();

  const [loginForm, setOpenLoginForm] = useState(false);
  const { getToken } = useUserStore();
  const { questionCategories, faqs, setCategoryId, setCompanyId, fetchData, message, video } = useDataStore();

  useEffect(() => {
    setCompanyId(companyId);
    fetchData();
  }, []);

  const token = getToken();

  const goToQuestion = (id) => {
    setCategoryId(id);
    setTimeout(() => {
      navigate(`/${companyId}/question/${id}`);
    }, 100);
  };

  if (message) {
    return (
      <Popup open={true} showCloseBtn={false} height='35vh'>
        <PageNotExist />
      </Popup>
    );
  }

  return (
    <>
      <YouAreAnonymous />
      <div className='root'>
        <Card>
          <React.Fragment>
            <div className='mb-3' style={{display: 'flex', justifyContent: 'flex-end'}}>
              <LangSwitcher />
              {!token ? <LoginButton title='login' onClick={() => setOpenLoginForm(true)} /> : <LoginButton title='login' onClick={() => navigate(`/case`)} />}
            </div>
            <section className='mb-5'>
              <HelpLineTitle />
              <p className='text-center'>{t`The safe and confidential space for your feedback`}</p>
            </section>
            <section className='mb-5'>
              <h2 style={{fontSize: '30px'}}>{t`Create a case by selecting a category below`}:</h2>
              <Flex style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '10px',
                width: '100%'
              }}>
                {questionCategories && questionCategories.map((item, i) => <Tag key={`tag_${i}`} title={item.title} icon={item.icon} cb={() => goToQuestion(item.id)} />)}
              </Flex>
            </section>
            <section className='mb-5'>
              <h2>{t`How does this work?`}</h2>
              <section className='mb-5 flex' style={{justifyContent: 'center', display: 'flex'}}>
                <HowItWork video={video} />
              </section>
              <Flex>
                <p>
                  {t`Feedback can be submitted on behalf of the individual or on behalf of someone whose situation they have witnessed. Employees may refrain from formally reporting workplace issues due to fears of retaliation or a lack of trust in the reporting process. Anonymous reporting addresses these concerns by allowing employees to report problems confidentially, fostering a safer and more trusting work environment.`}
                </p>
                <p>
                  {t`EasyLlama’s Anonymous Reporting allows employees to chat anonymously with an assigned administrator or manager in order to provide more details about their claim, or they can reveal their personal information during the submission process if they choose. Analytics will also be available to company administrators in order to track and assess trends in employee reporting.`}
                </p>
              </Flex>
            </section>
            <section className='mb-5'>
              <h2>{t`Frequently asked questions`}:</h2>
              {faqs && <Faq items={faqs} />}
            </section>

            {loginForm && (
              <Popup open={true} onClose={() => setOpenLoginForm(false)}>
                <PhoneNumberForm onSubmit={() => {
                  setOpenLoginForm(false);
                  navigate('/case');
                }} />
              </Popup>
            )}
          </React.Fragment>
        </Card>
      </div>
      <TermsConditions />
      <PoweredBy />
    </>
  );
};

export default Main;
